import type { HighlightAdapter } from '../highlight-adapter.js'
import type { SelectableFeatureRef } from '../selectable-feature-ref.js'
import type { BaseShape } from '../../../components/map/shapes/base-shape.js'

export class UserFeatureAdapter implements HighlightAdapter {
  readonly sources = ['user']

  constructor(private getShapeComponents: () => Map<string, BaseShape>) {}

  applyHighlights(refs: SelectableFeatureRef[]): void {
    const selectedIds = new Set(
      refs.filter(r => r.source === 'user').map(r => (r as { featureId: string }).featureId)
    )
    this.getShapeComponents().forEach((component, featureId) => {
      component.setSelected(selectedIds.has(featureId))
    })
  }

  clearHighlights(): void {
    this.getShapeComponents().forEach(component => {
      component.setSelected(false)
    })
  }
}
